import React from 'react';
import { motion } from 'framer-motion';
import { Utensils } from 'lucide-react';
import { Product } from '../../../types/Product';

interface MenuItemProductProps {
  product: Product;
}

export const MenuItemProduct: React.FC<MenuItemProductProps> = ({ product }) => {
  return (
    <motion.div
      whileHover={{ scale: 1.02 }}
      className="flex items-center gap-3 p-3 rounded-lg hover:bg-orange-50 transition-all group"
    >
      <div className="w-12 h-12 rounded-lg overflow-hidden">
        <img
          src={product.thumbnail}
          alt={product.display_name}
          className="w-full h-full object-cover"
        />
      </div>
      <div className="flex-1 min-w-0">
        <h4 className="font-medium text-gray-800 line-clamp-1">{product.display_name}</h4>
        <p className="text-sm text-gray-500">{product.brand}</p>
      </div>
      <div className="flex items-center gap-1 text-orange-500 font-semibold">
        <span>{product.current_price.toFixed(2)}€</span>
      </div>
    </motion.div>
  );
};